import React from 'react'
import TextField from '@material-ui/core/TextField'
import { Field } from 'redux-form'
import { translate } from 'react-admin'

const HEX_COLOR_REGEX = /^#[0-9A-Fa-f]{6}$/

const renderColorPicker = ({ input, label, meta: { touched, error } }) => {
  const isValidHex = HEX_COLOR_REGEX.test(input.value)
  return (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      <input
        type="color"
        // native color inputs require a strict #rrggbb value, fall back while typing an incomplete hex
        value={isValidHex ? input.value : '#000000'}
        onChange={(e) => input.onChange(e.currentTarget.value)}
        style={{ marginRight: '10px', width: '40px', height: '40px', padding: 0, border: 'none', cursor: 'pointer' }}
      />
      <TextField
        style={{ width: '47%' }}
        label={label}
        error={!!(touched && error)}
        helperText={touched && error}
        {...input}
      />
    </div>
  )
}

const ColorPicker = (props) => (
  <Field
    name="colorText"
    component={renderColorPicker}
    label={props.translate('main.color_hex', { _: 'Color in hexadecimal start with #' })}
  />
)

export default translate(ColorPicker)
